export const Msgs = {
  NotActiveMsg:
    "Your profile is pending for approval. Once your profile is verified and approved, You will be able to use this feature.",
};
